import React, { useEffect, useState }  from 'react';
import TabsItemOne from './TabsItemOne';
import TabItemOneToggler from './TabItemOneToggler';
import { RiArrowDownSLine } from 'react-icons/ri';
import { SlArrowRight } from 'react-icons/sl';

const TabsItemDropList = ({hendlerOpen, subTitle, title, eqv, setEqv, isOpen, setIsOpen, setIsOpenAside, isToggle, isToggleRules, isToggleMessage}) => {
    // const [isOpen, setIsOpen] = useState(false)
    const [openList, setOpenList] = useState(false)

    useEffect(() => {
        if (isOpen){
            setTimeout(() => {
                setOpenList(true)
            },100)
        } else setOpenList(false)
    },[isOpen])

    return (
        <div className={`asside_menu_server_tabs_wrap_drop-list ${isOpen? 'asside_menu_server_tabs_wrap_drop-list_open' : 'asside_menu_server_tabs_wrap_drop-list_close'}`}>
            <div className={`asside_menu_server_tabs_item`}
            onClick={() => hendlerOpen()}>
                <div className='asside_menu_server_tabs_item_name'>
                <img src={`/img/asside_icon/${title}.svg`} alt="" />
                <p>{title}</p>
                </div>
                <div className='asside_menu_server_tabs_item_svg'>
                    <RiArrowDownSLine
                        className={`close_svg ${isOpen? 'open_svg' : ''}`}
                        />
                </div>
            </div>
            <div className='tabs_drop-list'>
                {openList &&
                    <>
                        <TabItemOneToggler
                            title='Status'
                            subTitle={`${title}-Status`}
                            eqv={eqv}
                            setEqv={setEqv}
                            nesting={true}
                        setIsOpenAside={setIsOpenAside}
                        isToggle={isToggle}
                        />
                        {title ==='Verification' &&
                        <> 
                            <TabItemOneToggler
                            title='Rules'
                            subTitle={`${title}-Rules`}
                            eqv={eqv}
                            setEqv={setEqv}
                            nesting={true}
                            setIsOpenAside={setIsOpenAside}
                            isToggle={isToggleRules}
                        />
                            <TabItemOneToggler
                            title='Custom Message'
                            subTitle={`${title}-Custom Message`}
                            eqv={eqv}
                            setEqv={setEqv}
                            nesting={true}
                            setIsOpenAside={setIsOpenAside}
                            isToggle={isToggleMessage}
                        />
                        </>
                        }
                        <TabsItemOne
                            title='Logs'
                            subTitle={`${title}-Logs`}
                            eqv={eqv}
                            setEqv={setEqv}
                            nesting={true}
                            setIsOpenAside={setIsOpenAside}
                        />

                </>
                }
            </div>
        </div>
    );
};

export default TabsItemDropList;